import React from "react";
import App from "./screens/App";
import QrCode from "./screens/QrCode";

const Navigator = () => {
  // elementary navigation for the web app
  return window.location.pathname === "/secret/qrcode" ? <QrCode /> : <App />;
};
export default Navigator;
